import type { OnyxTableNotFound } from '@onyx/angular';

export const ASSIGNED_CONTRACTORS_NOT_FOUND: OnyxTableNotFound = {
  icon: { name: 'contractor-filled', size: 32 },
  title: 'pointsOfInterest.contractors.noContractors',
};
